import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import BootstrapVue from "bootstrap-vue";
import vSelect from "vue-select";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import VeeValidate from "vee-validate";
import * as VueGoogleMaps from "vue2-google-maps";
import AOS from "aos";
import "aos/dist/aos.css";
import api from "./api";
import Datepicker from "vuejs-datepicker";
import InputMask from "vue-input-mask";
import "../node_modules/nprogress/nprogress.css";
import "./registerServiceWorker";
import VueLazyload from "vue-lazyload";

Vue.config.productionTip = false;

const moment = require("moment");
require("moment/locale/es");

Vue.use(require("vue-moment"), {
  moment
});
Vue.use(BootstrapVue);
Vue.use(VeeValidate, {
  validity: true
});
Vue.component("v-select", vSelect);
Vue.component("VueSlider", VueSlider);
Vue.use(VueLazyload);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDw5IB-xsJf8R6AXweyl127gr6a_IxDxo8",
    libraries: "places"
  }
});
Vue.component("datepicker", Datepicker);
Vue.component("input-mask", InputMask);
Vue.use(VueLazyload);

AOS.init({
  once: true
});

declare var FB: any;
declare var gapi: any;
declare var dataLayer: any;

new Vue({
  router,
  store,
  render: h => h(App),
  data: function() {
    return {
      config: {},
      auth2: null,
      error_bt: [],
      experiences: [
        { id: "prof", internal_id: 0, description: "Profesionales" },
        { id: "digital", internal_id: 1, description: "Digitales" },
        { id: "oficio", internal_id: 2, description: "Oficio" },
        { id: "primer", internal_id: 3, description: "Primer Trabajo" },
        { id: "junior", internal_id: 4, description: "Junior" },
        { id: "semi", internal_id: 5, description: "Semi-senior" },
        { id: "senior", internal_id: 6, description: "Senior" },
        { id: "mamedio", internal_id: 7, description: "Mando medio" },
        { id: "gerencia", internal_id: 8, description: "Gerencia" },
        { id: "clevel", internal_id: 9, description: "C-level" }
      ],
      openMenu: false,
      emailRegex: /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i,
      windowWidth: 0,
      dataDefault: [
        {
          number: 4,
          numberT: 4,
          description: "Paises en latinoamerica",
          withSymbol: false
        },
        {
          number: 4,
          numberT: 4,
          description: "Areas estratégicas",
          withSymbol: false
        },
        {
          number: 4,
          numberT: 4,
          description: "Valores inamovibles",
          withSymbol: false
        },
        {
          number: 40,
          numberT: 40,
          description: "Años de experiencia",
          withSymbol: true
        }
      ]
    };
  },
  computed: {
    apiUrl() {
      return process.env.VUE_APP_API_URL;
    },
    isMobile() {
      return (this as any).windowWidth < 992;
    },
    isMob() {
      return (this as any).windowWidth < 768;
    }
  },
  async beforeMount() {
    const _this = this as any;
    _this.config = await api
      .init((this as any).apiUrl, (this as any).$store.state.token)
      .call("get", "cms/config", {});
    const css = `:root {${Object.keys(_this.config.colors)
        .map((key: any) => `${key}: ${_this.config.colors[key]}`)
        .join(";")};--bt-font: "${_this.config.font}"}`,
      head = document.head || document.getElementsByTagName("head")[0],
      style = document.createElement("style");
    head.appendChild(style);
    style.type = "text/css";
    if ((style as any).styleSheet) {
      (style as any).styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
  },
  mounted() {
    (this as any).googleInit();
    let params = window.location.search.substring(1).split("=");
    if (params[0] === "twitter") {
      let query = window.location.search.substring(1).split("&");
      let names = query[2].replace("first_name=", "").split("%20");
      (this as any).login(
        "twitter",
        `${query[1].replace("id=", "")}@twitter.com`,
        names[0],
        names[1],
        query[1].replace("id=", "")
      );
    } else if (params[0] === "code") {
      var response = (this.$root as any)
        ._post(`linkedin`, {
          code: params[1]
        })
        .then((response: any) => {
          window.history.replaceState("Linkedin", "Linkedin", "/");
          (this as any).login(
            "linkedin",
            response.email,
            response.first_name,
            response.last_name,
            response.id
          );
        });
       //este login FIJO solo fue para poder probar en ambiente de TEST
       //(this as any).login("linkedin","aaa@aaa.com","pepe","lopez","1234");
        
    }
  },
  methods: {
    addOgs(title: string, url: string, description: string, banner: string) {
      Array.from(
        document.querySelectorAll("[data-vue-router-controlled-image]")
      ).forEach((el: any) => el.parentNode.removeChild(el));
      Array.from(
        document.querySelectorAll("[data-vue-router-controlled-image-twitter]")
      ).forEach((el: any) => el.parentNode.removeChild(el));

      document
        .querySelectorAll("meta[property]")
        .forEach((el: any) => el.parentNode.removeChild(el));

      document.title = title;

      let tag = document.createElement("meta");
      tag.setAttribute("property", "og:title");
      tag.setAttribute("content", title);
      document.head.appendChild(tag);

      let metaDescription = document.querySelector("meta[name='description']");
      if (metaDescription) metaDescription.setAttribute("content", description);
      else {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        tag.setAttribute("content", description);
        document.head.appendChild(tag);
      }

      tag = document.createElement("meta");
      tag.setAttribute("property", "og:url");
      tag.setAttribute("content", url);
      document.head.appendChild(tag);

      tag = document.createElement("meta");
      tag.setAttribute("property", "og:description");
      tag.setAttribute("content", description);
      document.head.appendChild(tag);

      tag = document.createElement("meta");
      tag.setAttribute("property", "og:image");
      tag.setAttribute("content", banner);
      tag.setAttribute("data-vue-router-controlled-image", "");
      document.head.appendChild(tag);

      let tagTwitter = document.createElement("meta");
      tagTwitter.setAttribute("name", "twitter:image");
      tagTwitter.setAttribute("content", banner);
      tagTwitter.setAttribute("data-vue-router-controlled-image-twitter", "");
      document.head.appendChild(tagTwitter);
    },
    getPhoneCountryCode(code: any) {
      if (!code) return "+___";
      code = code.replace("+", "");
      if (code.length > 3) return "+___";
      if (code.length === 1) return `+__${code}`;
      if (code.length === 2) return `+_${code}`;
      if (code.length === 3) return `+${code}`;
    },
    getPhoneAreaCode(code: any) {
      if (!code) return "(____)";
      code = code.replace("(", "").replace(")", "");
      if (code.length > 4) return "(____)";
      if (code.length === 1) return `(___${code})`;
      if (code.length === 2) return `(__${code})`;
      if (code.length === 3) return `(_${code})`;
      if (code.length === 4) return `(${code})`;
    },
    getPhoneNumber(code: any) {
      if (!code) return "________";
      if (code.length > 8) return "________";
      if (code.length === 1) return `_______${code}`;
      if (code.length === 2) return `______${code}`;
      if (code.length === 3) return `_____${code}`;
      if (code.length === 4) return `____${code}`;
      if (code.length === 5) return `___${code}`;
      if (code.length === 6) return `__${code}`;
      if (code.length === 7) return `_${code}`;
      if (code.length === 8) return `${code}`;
    },
    showLoginModal($event: any, forceDesktop: boolean) {
      const header: any = (this as any).$children[0].$children[0].$children.find(
        (t: any) => t.$options._componentTag === "Header"
      );
      if (window.innerWidth > 768 || forceDesktop) {
        header.$refs["login-modal"].show();
      } else {
        header.openLogin = true;
      }
    },
    getUrl(url: any) {
      return (
        "/" +
        url
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase()
          .replace(/ /g, "-")
      );
    },
    facebookLogin() {
      const _this: any = this;
      FB.login(
        (response: any) => {
          if (response.status === "connected") {
            FB.api(
              "/me?fields=id,name,email",
              (response: any) => {
                _this.login(
                  "facebook",
                  response.email,
                  response.name,
                  "",
                  response.id
                );
              },
              { scope: "email,public_profile,user_friends" }
            );
          } else if (response.status === "not_authorized") {
            console.log(response);
          } else {
            console.log(response);
          }
        },
        { scope: "email,public_profile" }
      );
    },
    googleInit() {
      let GoogleCreds = {
        id: process.env.VUE_APP_GOOGLE_ID,
        secret: process.env.VUE_APP_GOOGLE_SECRET
      };
      let i: any = setInterval(() => {
        if ((window as any).gapi) {
          window.clearInterval(i);
          gapi.load("auth2", () => {
            gapi.auth2
              .init({
                client_id: GoogleCreds.id,
                cookiepolicy: "single_host_origin"
              })
              .then((auth2: any) => {
                (this as any).auth2 = auth2;
              });
          });
        }
      }, 100);
    },
    googleLogin() {
      (this as any).auth2.signIn().then((googleUser: any) => {
        (this as any).login(
          "google",
          googleUser.getBasicProfile().getEmail(),
          googleUser.getBasicProfile().getGivenName(),
          googleUser.getBasicProfile().getFamilyName(),
          googleUser.getBasicProfile().getId()
        );
      });
    },
    linkedinLogin() {
    
     (window as any).location = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${process.env.VUE_APP_LINKEDIN_CLIENT_ID}&redirect_uri=${process.env.VUE_APP_LINKEDIN_CALLBACK}&state=${process.env.VUE_APP_LINKEDIN_STATE}&scope=r_liteprofile%20r_emailaddress`;
      //(this as any).login("linkedin","aaa@aaa.com","pepe","lopez","1234");
    },
    twitterLogin() {
      (window as any).location = `${(this as any).apiUrl}twitter`;
    },
    addTooltip($event: any) {
      setTimeout(function() {
        let node: any = document.evaluate(
          "//span[contains(., '" + $event.description + "')]",
          document,
          null,
          XPathResult.FIRST_ORDERED_NODE_TYPE,
          null
        ).singleNodeValue;
        node = node.parentNode.parentNode;
        let tooltip: any = node.parentNode.querySelector(".v-select-tooltip");
        if (tooltip) tooltip.remove();
        let newEl: any = document.createElement("div");
        newEl.classList.add("v-select-tooltip");
        newEl.innerHTML = $event.description;
        node.parentNode.insertBefore(newEl, node);
      }, 1000);
    },
    async reloadUser() {
      const response = await (this.$root as any)._get(
        "user/one/?includes=users_experiences,users_professionals,users_languages,users_educations,offers"
      );
      this.$store.commit("setUser", response.data[0]);
    },
     async reloadUser2(res: any) {
       this.$store.commit("setUser", res.user);
     },
    async login(
      network: string,
      email: string,
      first_name: string,
      last_name: string,
      id: string
    ) {
      let _this: any = this;
      try {
        var response = await _this.$root._post(`user/login/${network}`, {
          username: email,
          email,
          first_name,
          last_name,
          [`${network}_id`]: id,
          nucleus_user: {
            d_apellido: last_name,
            d_email: email,
            d_nombres: first_name,
            estudiosCV: []
          },
          role: 2
        });
        if ((window as any).location.pathname.indexOf("bienvenida") >= 0) {
          dataLayer.push({
            event: "Event",
            category: "engagement",
            action: "sign_up",
            label: network
          });
        } else {
          dataLayer.push({
            event: "Event",
            category: "engagement",
            action: "login",
            label: network
          });
        }
        _this.$store.commit("setToken", response.token);
        //review 
        if(!response.user.id)
          await _this.reloadUser2(response);
        else 
          await _this.reloadUser();
          
        let quick_offer = localStorage.getItem("bayton-quick-offer");
        if (quick_offer) {
          localStorage.removeItem("bayton-quick-offer");
          if (_this.$store.state.user.active) {
            (window as any).location = `/ofertas/${quick_offer}?quick=1`;
          } else {
            return ((window as any).location = "/crear-cuenta");
          }
        } else {
          return ((window as any).location = `/bienvenida`);
        }
      } catch (e) {
        if (e.message === "Email already in use") {
          alert("Ya existe un usuario con el mail " + email);
        }
      }
    },
    isUnder18(birthday: any) {
      const age = moment().diff(birthday, "years");
      return age < 18;
    },
    hover(offers: any) {
      offers.hover = !offers.hover;
    },
    clickNetwork(offers: any) {
      offers.network = !offers.network;
    },
    isDesktop(min = 992) {
      return window.innerWidth >= min;
    },
    scrollIt(id: string) {
      (document as any)
        .querySelector("#" + id)
        .scrollIntoView({ behavior: "smooth" });
    },
    animateValue(data: any) {
      var current = 0;
      var timer = setInterval(() => {
        current += 1;
        for (let i = 0; i < 4; i++) {
          data[i].numberT = Math.ceil((current * data[i].number) / 100);
        }
        if (current === 100) {
          clearInterval(timer);
        }
      }, 7);
    },
    _get(path: string, params: Record<string, any>) {
      return api
        .init((this as any).apiUrl, (this as any).$store.state.token)
        .call("get", path, params);
    },
    _post(path: string, params: Record<string, any>) {
      return api
        .init((this as any).apiUrl, (this as any).$store.state.token)
        .call("post", path, params);
    },
    _delete(path: string, params: Record<string, any>) {
      return api
        .init((this as any).apiUrl, (this as any).$store.state.token)
        .call("delete", path, params);
    },
    _put(path: string, params: Record<string, any>) {
      return api
        .init((this as any).apiUrl, (this as any).$store.state.token)
        .call("put", path, params);
    },
    _file(path: string, method: string, file: any) {
      return api
        .init((this as any).apiUrl, (this as any).$store.state.token)
        .file(method, path, file);
    },
    async validateBeforeSubmit(elements: string[], user: any) {
      const _this: any = this;
      _this.error_bt = [];
      elements.forEach((key: string) => {
        if (user[key] === "" || user[key] === null) {
          _this.error_bt.push(key as never);
          if (user[key] === null) {
            user[key] = "";
          }
        } else {
          if (key === "to" && user["from"]) {
            let from = typeof(user["from"]) === "string" ? new Date(user["from"]) : user["from"];
            if (user["to"] < from) {
              _this.error_bt.push("to");
            }
          }
          if (key === "email") {
            if ((this as any).validateEmail(user[key])) {
              _this.error_bt.slice(_this.error_bt.indexOf(key as never));
            } else {
              _this.error_bt.push(key as never);
            }
          } else {
            _this.error_bt.slice(_this.error_bt.indexOf(key as never));
          }
        }
      });
      if (_this.error_bt.length) {
        _this.error_bt.forEach((item: any) => {
          if (item === "checked1") user[item] = false;
          else if (item !== "email" && item !== "to") user[item] = null;
        });
      }
    },
    formatDate(val: any) {
      let day = "",
        month = "";
      month = moment(val)
        .locale("es")
        .format("MMMM");
      day = moment(val)
        .locale("es")
        .format("DD");
      return day + " de " + month.charAt(0).toUpperCase() + month.slice(1);
    },
    menuBt() {
      (this as any).openMenu = !(this as any).openMenu;
      if ((this as any).openMenu) {
        document.body.classList.add("scroll-lock");
      } else {
        document.body.classList.remove("scroll-lock");
      }
    },
    parsePhone(phone: string) {
      let nu_pais = "";
      let nu_area = "";
      let nu_nro = "";
      if (phone) {
        nu_pais = phone
          .substring(1, 4)
          .replace(/_/g, "")
          .trim();
        nu_area = phone
          .substring(5, 9)
          .replace(/_/g, "")
          .trim();
        nu_nro = phone
          .substring(10)
          .replace(/_/g, "")
          .trim();
      }
      return { nu_nro, nu_area, nu_pais };
    },
    validateEmail(email: any) {
      return (this as any).emailRegex.test(email);
    },
    handleResize() {
      (this as any).windowWidth = window.innerWidth;
    },
    validateNumber(cel: any) {
      const _this: any = this;
      let phone: any = _this.parsePhone(cel);
      let error_phone = {
        flag: true,
        type: 1
      };
      if (cel !== "" && cel !== null) {
        if (parseInt(phone.nu_pais) === 54) {
          if (
            phone.nu_nro !== "" &&
            parseInt(phone.nu_nro.toString().substring(0, 2)) === 15
          ) {
            error_phone.flag = false;
            error_phone.type = 3;
          }
          if (
            (phone.nu_area !== "" &&
              parseInt(phone.nu_area.split("")[0]) > 3) ||
            phone.nu_area.split("")[0] === "0"
          ) {
            error_phone.flag = false;
            error_phone.type = 2;
          }
          if (phone.nu_nro === "" && phone.nu_area !== "") {
            error_phone.flag = false;
            error_phone.type = 1;
          }
        } else {
          if (
            phone.nu_nro &&
            phone.nu_nro !== "" &&
            phone.nu_area !== "" &&
            phone.nu_pais !== ""
          ) {
            error_phone.flag = true;
            error_phone.type = 0;
          } else {
            error_phone.flag = false;
            error_phone.type = 0;
          }
        }
      }
      return error_phone;
    },
    getfcierre(offer: any) {
      return moment().isBefore(offer.f_cierre);
    },
    getContainerList(container_id: any) {
      var i = setInterval(() => {
        let container: any = document.getElementsByClassName(container_id);
        if (container && container.length) {
          clearInterval(i);
          setTimeout(() => {
            (this as any).scrollIt(this.$route.hash.replace("#", ""));
          }, 1000);
        }
      });
    },
    spinalCase(str: string) {
      var spinal = str
        .replace(/(?!^)([A-Z])/g, " $1")
        .replace(/[_\s]+(?=[a-zA-Z])/g, "-")
        .toLowerCase();
      return spinal;
    },
    checkForSocialMediaKey(network: string) {
      const networks: any = {
        facebook: "VUE_APP_FACEBOOK_ID",
        google: "VUE_APP_GOOGLE_ID",
        linkedin: "VUE_APP_LINKEDIN_CLIENT_ID",
        twitter: "VUE_APP_TWITTER_ID"
      };
      return process.env[networks[network]] ? true : false;
    },
    filterByKeyword(label: any, search: string) {
      return (
        (label || "")
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .indexOf(
            search
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
          ) > -1
      );
    },
  }
}).$mount("#app");
